"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var experimentToggleListType_1 = require("../experiment/experimentToggleListType");
var processList_1 = require("../utils/processList");
/**
 * Toggle numbering at selection
 * If selection contains numbering in deep level, toggle numbering will decrease the numbering level by one
 * If selection contains bullet list, toggle numbering will convert the bullet list into number list
 * If selection contains both bullet/numbering and normal text, the behavior is decided by corresponding
 * realization of browser execCommand API
 * @param editor The editor instance
 */
function toggleNumbering(editor) {
    if (editor.useExperimentFeatures()) {
        experimentToggleListType_1.default(editor, 1 /* Ordered */);
    }
    else {
        editor.focus();
        editor.addUndoSnapshot(function () { return processList_1.default(editor, "insertOrderedList" /* InsertOrderedList */); }, "Format" /* Format */);
    }
}
exports.default = toggleNumbering;
//# sourceMappingURL=toggleNumbering.js.map